import React,{useEffect, useState} from 'react'
import ComponentLogo from '../Components/ComponentLogo' 
import ProductosLista from '../Components/ProductosLista'
import Filtro_consulta1 from '../Components/filtros/Filtro_consulta1'
import Filtro_consulta2 from '../Components/filtros/Filtro_consulta2'
import Filtro_consulta3 from '../Components/filtros/Filtro_consulta3'
import Filtro_consulta4 from '../Components/filtros/Filtro_consulta4'
import Filtro_consulta5 from '../Components/filtros/Filtro_consulta5'
import Filtro_consulta6 from '../Components/filtros/Filtro_consulta6'
import Filtro_consulta7 from '../Components/filtros/Filtro_consulta7'
import Filtro_consulta8 from '../Components/filtros/Filtro_consulta8'
import Filtro_consulta9 from '../Components/filtros/Filtro_consulta9'


const Navidad_Page = () => {

  const [subcategoria, setSubcategoria] = useState('todo')

  const miFiltro = (value) => {     
    console.log(subcategoria)
    setSubcategoria(value)

  }

  
  return (
    <>
        <ComponentLogo />
        <div id="productos_categoria">

        <div className='filtro'>
            <div>
                <ul className='filtro_lista'>
                    <li onClick={() => miFiltro("todo")} className='filtro_item'><img alt='todo' src='https://firebasestorage.googleapis.com/v0/b/miladetallesweb.appspot.com/o/products%2Ficonos%2Fhoja-de-calculo.png?alt=media&token=4bc599fa-3878-46c8-965b-1e6b9493489a'/><p>Todo</p></li>
                    <li onClick={() => miFiltro("nacimientos")} className='filtro_item'><img alt='nacimientos' src='https://firebasestorage.googleapis.com/v0/b/miladetallesweb.appspot.com/o/products%2Ficonos%2Fjesus.png?alt=media&token=46772ecf-8fd1-4442-b257-90005db87bca'/><p filtro_subcategoria='nacimientos'>Nacimientos</p></li>
                    <li onClick={() => miFiltro("adornosmusicales")} className='filtro_item'><img alt='adornos_musicales' src='https://firebasestorage.googleapis.com/v0/b/miladetallesweb.appspot.com/o/products%2Ficonos%2Ffloor-lamp.png?alt=media&token=664f4a52-e020-470f-83cc-2bdb0f1357b0'/><p filtro_subcategoria='adornosmusicales'>Adornos musicales</p></li>
                    <li onClick={() => miFiltro("manteleria")} className='filtro_item'><img alt='manteleria' src='https://firebasestorage.googleapis.com/v0/b/miladetallesweb.appspot.com/o/products%2Ficonos%2Fmanteles.png?alt=media&token=f74636b8-eab3-4cf2-9aba-c20ad4e58b06' /><p filtro_subcategoria='manteleria'>Mantelería</p></li>
                    <li onClick={() => miFiltro("cojines")} className='filtro_item'><img alt='cojines' src='https://firebasestorage.googleapis.com/v0/b/miladetallesweb.appspot.com/o/products%2Ficonos%2Falmohadas-de-cama.png?alt=media&token=c6610272-3033-439a-a65a-cbc490689ec4'/><p filtro_subcategoria='cojines'>Cojínes</p></li>
                    <li onClick={() => miFiltro("centroycoronas")} className='filtro_item'><img alt='coronas' src='https://firebasestorage.googleapis.com/v0/b/miladetallesweb.appspot.com/o/products%2Ficonos%2Fcorona-de-navidad.png?alt=media&token=c9491f5b-6598-4a00-bf30-4523ad6f905a'/><p filtro_subcategoria='centroycoronas'>Coronas</p></li>
                    <li onClick={() => miFiltro("farolesyvelas")} className='filtro_item'><img alt='faroles' src='https://firebasestorage.googleapis.com/v0/b/miladetallesweb.appspot.com/o/products%2Ficonos%2Ffarola.png?alt=media&token=1090f572-f2a3-43ab-a228-9d38b77f4d1a'/><p filtro_subcategoria='farolesyvelas'>Faroles|Velas</p></li>
                    <li onClick={() => miFiltro("adornosarbol")} className='filtro_item'><img alt='adornos_arbol' src='https://firebasestorage.googleapis.com/v0/b/miladetallesweb.appspot.com/o/products%2Ficonos%2Fadornos.png?alt=media&token=e4a3a1fd-9999-4988-9599-9f6910bea3a2'/><p filtro_subcategoria='adornosarbol'>Adornos de árbol</p></li>
                    <li onClick={() => miFiltro("acrilico")} className='filtro_item'><img alt='acrilico' src='https://firebasestorage.googleapis.com/v0/b/miladetallesweb.appspot.com/o/products%2Ficonos%2Fbola-de-navidad.png?alt=media&token=d787ea54-c932-4ef6-a961-b2fc7675f126'/><p filtro_subcategoria='acrilico'>Acrílicos</p></li>
                    <li onClick={() => miFiltro("cascanueces")} className='filtro_item'><img alt='cascanueces' src='https://firebasestorage.googleapis.com/v0/b/miladetallesweb.appspot.com/o/products%2Ficonos%2Fcascanueces.png?alt=media&token=fac8b803-b6bf-4785-a584-36911f8f1388'/><p  filtro_subcategoria='cascanueces'>Cascanueces</p></li>
                </ul>
            </div>
        </div>
          {
            subcategoria === 'todo' ?(  
              <ProductosLista  query_data={'navidad'}/>
            ):(
              {
                'todo':
                  <ProductosLista  query_data={'navidad'}/>,
                'nacimientos':
                  <Filtro_consulta1 filtro_subcategoria={'nacimientos'}/>,                
                'adornosmusicales':
                  <Filtro_consulta2 filtro_subcategoria={'adornosmusicales'}/>,
                'manteleria':
                  <Filtro_consulta3 filtro_subcategoria={'manteleria'}/>,
                'cojines':
                  <Filtro_consulta4 filtro_subcategoria={'cojines'}/>,
                'centroycoronas':
                  <Filtro_consulta5 filtro_subcategoria={'centroycoronas'}/>,
                'farolesyvelas':
                  <Filtro_consulta6 filtro_subcategoria={'farolesyvelas'}/>,
                'adornosarbol':
                  <Filtro_consulta7 filtro_subcategoria={'adornosarbol'}/>,
                'acrilico':
                  <Filtro_consulta8 filtro_subcategoria={'acrilico'}/>,
                'cascanueces':
                  <Filtro_consulta9 filtro_subcategoria={'cascanueces'}/>
              }[subcategoria]
            ) 
          }
      </div>  
    </>
  )
}

export default Navidad_Page